/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
let t=0;const n=0;function e(){return++t}export{n as NullUID,e as generateUID};
